import { Categories, FullAddress } from '../locations';
import { useSelector } from 'react-redux';
import MMap, { GAutoComplete } from '../MMap';
import { Sidebar, RMap } from '../Sidebar';
import MapRadius from '../MapRadius';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
const ListLayout = () => {
    var SiteData = useSelector(state => state.SiteData);
    const headerColor = SiteData.header_color ? SiteData.header_color : '#fff';
    const sliderColor = SiteData.sliderColor ? SiteData.sliderColor : '#0000ff';
    const headerTextColor = SiteData.header_text_color ? SiteData.header_text_color : '#000';

    const clusterColor = SiteData.cluster_color ? SiteData.cluster_color : '#fff';
    const clusterTextColor = SiteData.cluster_text_color ? SiteData.cluster_text_color : '#0000ff';
    var Storeclicked = useSelector(state => state.Storeclicked);
    const sidebarPosition = SiteData.sidebarposition;
    const gridClass = ('bottom-grid' === sidebarPosition) ? 'rslBottomSidebar rslGridStore' : 'rslBottomSidebar';
    const mapXs = ('hide' === sidebarPosition || 'bottom-list' === sidebarPosition || 'bottom-grid' === sidebarPosition) ? 12 : 6;
    const mapMd = ('hide' === sidebarPosition || 'bottom-list' === sidebarPosition || 'bottom-grid' === sidebarPosition) ? 12 : 8;
    const barXs = ('hide' === sidebarPosition || 'bottom-list' === sidebarPosition || 'bottom-grid' === sidebarPosition) ? 12 : 6;
    const barMd = ('hide' === sidebarPosition || 'bottom-list' === sidebarPosition || 'bottom-grid' === sidebarPosition) ? 12 : 4;
    var mdSize2 = 6;
    if ( SiteData.hidesetaddress || SiteData.hidecategories ) {
        mdSize2 = 12;
    }
    return (
    <Container maxWidth="xl">
        <style>
            {`
            div.rslRadiusSLider span.MuiSlider-valueLabel{
                background:${headerTextColor}!important;
            }
            div.rslRadiusSLider span.MuiSlider-valueLabel span{
                color:${headerColor}!important;
            }
            .rslCountryStateCity input{
                color:${headerTextColor};
                background:none!important;
                box-shadow:none!important;
                border:none;
            }
            .rslCountryStateCity label, .rslCountryStateCity svg, .rslRadiusSLider p{
                color:${headerTextColor}!important;
            }
            .rslCountryStateCity fieldset{
                border-color:${headerTextColor}!important;
                background:transparent;
            }
            .rslRadiusSLider span{
                color:${sliderColor};
            }
            .categories_dropdown label, .categories_dropdown div, .categories_dropdown svg{
                color:${headerTextColor}!important;
            }
            .categories_dropdown fieldset{
                border-color:${headerTextColor}!important;
                background:transparent;
            }
            input.autocompletefields{
                width:80%;
                color:${headerTextColor}!important;
                border:1px solid ${headerTextColor}!important;
                background:${headerColor}!important;
            }
            input.autocompletefields::placeholder{
                color:${headerTextColor}!important;
                opacity:1;
            }
            .cluster-marker{
                color:${clusterTextColor};
                background:${clusterColor};
            }
        `}
        </style>
        {!SiteData.hideheader ?
        <Box sx={{ flexGrow: 1 }}>
            <Grid container className="rslStoresHeader" style={{background:headerColor}}>
                <Grid item xs={12} md={6}>
                    <GAutoComplete />
                </Grid>
                <Grid item xs={12} md={6}>
                    {!SiteData.hiderange ? <MapRadius /> : ''}
                </Grid>
                <Grid item xs={12} md={mdSize2}>
                    {!SiteData.hidecategories ? <Categories /> : ''}
                </Grid>
                <Grid item xs={12} md={mdSize2}>
                    {!SiteData.hidesetaddress ? <FullAddress /> : ''}
                </Grid>
            </Grid>
        </Box> : ''}
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                {('left' === sidebarPosition || !sidebarPosition) ? <Grid item xs={barXs} md={barMd}><div className="storelocations"><Sidebar /></div></Grid> : ''}
                <Grid item xs={mapXs} md={mapMd}>
                    { Storeclicked.clicked ? <RMap /> : <MMap /> }
                </Grid>
                {'right' === sidebarPosition ? <Grid item xs={barXs} md={barMd}><div className="storelocations"><Sidebar /></div></Grid> : ''}
            </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
            {('bottom-list' === sidebarPosition || 'bottom-grid' === sidebarPosition) ? <Grid container spacing={2} className={gridClass}><Sidebar /></Grid> : ''}
        </Box>
    </Container>
    );
}
export default ListLayout;